const COUNTRY_LANGUAGE_LIST = {
  us: {
    name: 'ct_us',
    code: 'us',
    languages: [{ code: 'en', name: 'lng_en' }],
    hasWebApp: false,
    hasOperations: false,
    immediateLoan: false,
    terms_conditions: false,
    privacy_policy: false,
    cookies_policy: true,
    nbcb: false,
  },
  ng: {
    name: 'ct_ng',
    code: 'ng',
    languages: [{ code: 'en', name: 'lng_en' }],
    hasWebApp: true,
    hasOperations: true,
    immediateLoan: true,
    canGetLoan: false,
    terms_conditions: true,
    privacy_policy: false,
    cookies_policy: true,
    nbcb: false,
  },
  pl: {
    name: 'ct_pl',
    code: 'pl',
    languages: [
      { code: 'pl', name: 'lng_pl' },
      { code: 'en', name: 'lng_en' },
    ],
    hasWebApp: false,
    hasOperations: true,
    immediateLoan: false,
    terms_conditions: false,
    privacy_policy: true,
    cookies_policy: true,
    nbcb: false,
  },
  cz: {
    name: 'ct_cz',
    code: 'cz',
    languages: [
      { code: 'cs', name: 'lng_cs' },
      { code: 'en', name: 'lng_en' },
    ],
    hasWebApp: false,
    hasOperations: true,
    immediateLoan: false,
    terms_conditions: false,
    privacy_policy: true,
    cookies_policy: true,
    nbcb: true,
  },
};

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
let countriesWithInvestors = ['none'];
if (activeEnv !== 'production') {
  countriesWithInvestors = [COUNTRY_LANGUAGE_LIST.us.code];
}
const notAvailableForCZ = Object.values(COUNTRY_LANGUAGE_LIST).map((def) => {
  if (def.code !== COUNTRY_LANGUAGE_LIST.cz.code) return def.code;
  return undefined;
});

const BASELINKS = [
  {
    to: '/home/',
    label: 'web.navigation.home',
  },
  {
    to: '/why_lidya/',
    label: 'web.navigation.why.lidya',
  },
  {
    to: '/how_works/',
    label: 'web.navigation.how.works',
    availableFor: notAvailableForCZ,
  },
  {
    to: '/news/',
    label: 'web.navigation.news',
  },
  {
    to: '/about_us/',
    label: 'web.navigation.about.us',
  },
  {
    to: '/careers/',
    label: 'web.navigation.careers',
  },
  // {
  //   to: '/investors/',
  //   label: 'web.navigation.investors',
  //   availableFor: countriesWithInvestors,
  // },
];

const COMPONENTS = {
  HOME: 'home',
  WHYLIDYA: 'why_lidya',
  HOWWORKS: 'how_works',
  ABOUTUS: 'about_us',
  CAREERS: 'careers',
  NEWS: 'news',
  // INVESTORS: 'investors',
  TERMSCONDITIONSJOBS: 'terms_conditions_job',
  TERMSCONDITIONS: 'terms_conditions',
  PRIVACYPOLICY: 'privacy_policy',
  COOKIES: 'cookies_policy',
  NBCB: 'nbcb',
  COMMUNICATION: 'news/communication',
  404: '404',
};

exports.availableLanguages = [
  {
    country: 'us',
    languages: ['en'],
    links: [
      {
        slug_en: 'home',
        component: COMPONENTS.HOME,
        label: 'web.navigation.home',
        main: true,
        footer: true,
      },
      {
        slug_en: 'why-lidya',
        slug_old: 'why_lidya',
        component: COMPONENTS.WHYLIDYA,
        label: 'web.navigation.why.lidya',
        main: true,
        footer: true,
      },
      {
        slug_en: 'how-works',
        slug_old: 'how_works',
        component: COMPONENTS.HOWWORKS,
        label: 'web.navigation.how.works',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news',
        component: COMPONENTS.NEWS,
        label: 'web.navigation.news',
        main: true,
        footer: true,
      },
      {
        slug_en: 'about-us',
        slug_old: 'about_us',
        component: COMPONENTS.ABOUTUS,
        label: 'web.navigation.about.us',
        main: true,
        footer: true,
      },
      {
        slug_en: 'careers',
        component: COMPONENTS.CAREERS,
        label: 'web.navigation.careers',
        main: true,
        footer: true,
      },

      // {
      //   slug_en: 'investors',
      //   component: COMPONENTS.INVESTORS,
      //   label: 'web.navigation.investors',
      //   main: true,
      //   footer: true,
      // },
      {
        slug_en: 'news/communication',
        component: COMPONENTS.COMMUNICATION,
        label: 'web.navigation.communication',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'terms-conditions-job',
        slug_old: 'terms_conditions_job',
        component: COMPONENTS.TERMSCONDITIONSJOBS,
        label: 'web.footer.terms.conditions',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'cookies',
        slug_old: 'cookies_policy',
        component: COMPONENTS.COOKIES,
        label: 'web.landing.cookie.link',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: '404',
        component: COMPONENTS['404'],
        label: 'web.404.title',
        main: false,
        footer: false,
      },
    ],
  },
  {
    country: 'ng',
    languages: ['en'],
    links: [
      {
        slug_en: 'home',
        component: COMPONENTS.HOME,
        label: 'web.navigation.home',
        main: true,
        footer: true,
      },
      {
        slug_en: 'why-lidya',
        slug_old: 'why_lidya',
        component: COMPONENTS.WHYLIDYA,
        label: 'web.navigation.why.lidya',
        main: true,
        footer: true,
      },
      {
        slug_en: 'how-works',
        slug_old: 'how_works',
        component: COMPONENTS.HOWWORKS,
        label: 'web.navigation.how.works',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news',
        component: COMPONENTS.NEWS,
        label: 'web.navigation.news',
        main: true,
        footer: true,
      },
      {
        slug_en: 'about-us',
        slug_old: 'about_us',
        component: COMPONENTS.ABOUTUS,
        label: 'web.navigation.about.us',
        main: true,
        footer: true,
      },
      {
        slug_en: 'careers',
        component: COMPONENTS.CAREERS,
        label: 'web.navigation.careers',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news/communication',
        component: COMPONENTS.COMMUNICATION,
        label: 'web.navigation.communication',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'terms-conditions',
        slug_old: 'terms_conditions',
        component: COMPONENTS.TERMSCONDITIONS,
        label: 'web.footer.terms.conditions',
        main: false,
        footer: true,
        new_tab: true,
      },
      {
        slug_en: 'terms-conditions-job',
        slug_old: 'terms_conditions_job',
        component: COMPONENTS.TERMSCONDITIONSJOBS,
        label: 'web.footer.terms.conditions',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'cookies',
        component: COMPONENTS.COOKIES,
        label: 'web.landing.cookie.link',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: '404',
        component: COMPONENTS['404'],
        label: 'web.404.title',
        main: false,
        footer: false,
      },
    ],
  },
  {
    country: 'pl',
    languages: ['en', 'pl'],
    links: [
      {
        slug_en: 'home',
        slug_pl: 'home',
        component: COMPONENTS.HOME,
        label: 'web.navigation.home',
        main: true,
        footer: true,
      },
      {
        slug_en: 'why-lidya',
        slug_pl: 'dlaczego-lidya',
        slug_old: 'why_lidya',
        component: COMPONENTS.WHYLIDYA,
        label: 'web.navigation.why.lidya',
        main: true,
        footer: true,
      },
      {
        slug_en: 'how-works',
        slug_pl: 'jak-dzialamy',
        slug_old: 'how_works',
        component: COMPONENTS.HOWWORKS,
        label: 'web.navigation.how.works',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news',
        slug_pl: 'aktualnosci',
        component: COMPONENTS.NEWS,
        label: 'web.navigation.news',
        main: true,
        footer: true,
      },
      {
        slug_en: 'about-us',
        slug_pl: 'o-nas',
        slug_old: 'about_us',
        component: COMPONENTS.ABOUTUS,
        label: 'web.navigation.about.us',
        main: true,
        footer: true,
      },
      {
        slug_en: 'careers',
        slug_pl: 'kariera',
        slug_old: 'careers',
        component: COMPONENTS.CAREERS,
        label: 'web.navigation.careers',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news/communication',
        slug_pl: 'aktualnosci/Komunikacja',
        component: COMPONENTS.COMMUNICATION,
        label: 'web.navigation.communication',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'privacy-policy',
        slug_pl: 'polityka-prywatnosci',
        slug_old: 'privacy_policy',
        component: COMPONENTS.PRIVACYPOLICY,
        label: 'web.footer.privacy.policy',
        main: false,
        footer: true,
        new_tab: true,
      },
      {
        slug_en: 'terms-conditions-job',
        slug_pl: 'polityka-prywatnosci-stanowisko',
        slug_old: 'terms_conditions_job',
        component: COMPONENTS.TERMSCONDITIONSJOBS,
        label: 'web.footer.terms.conditions',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'cookies',
        slug_pl: 'cookies',
        component: COMPONENTS.COOKIES,
        label: 'web.landing.cookie.link',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: '404',
        slug_pl: '404',
        component: COMPONENTS['404'],
        label: 'web.404.title',
        main: false,
        footer: false,
      },
    ],
  },
  {
    country: 'cz',
    languages: ['en', 'cs'],
    links: [
      {
        slug_en: 'home',
        slug_cs: 'home',
        component: COMPONENTS.HOME,
        label: 'web.navigation.home',
        main: true,
        footer: true,
      },
      {
        slug_en: 'why-lidya',
        slug_cs: 'proc-lidya',
        slug_old: 'why_lidya',
        component: COMPONENTS.WHYLIDYA,
        label: 'web.navigation.why.lidya',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news',
        slug_cs: 'zpravy',
        component: COMPONENTS.NEWS,
        label: 'web.navigation.news',
        main: true,
        footer: true,
      },
      {
        slug_en: 'about-us',
        slug_cs: 'o-nas',
        slug_old: 'about_us',
        component: COMPONENTS.ABOUTUS,
        label: 'web.navigation.about.us',
        main: true,
        footer: true,
      },
      {
        slug_en: 'careers',
        slug_cs: 'kariera',
        slug_old: 'careers',
        component: COMPONENTS.CAREERS,
        label: 'web.navigation.careers',
        main: true,
        footer: true,
      },
      {
        slug_en: 'news/communication',
        slug_cs: 'zpravy/Komunikace',
        component: COMPONENTS.COMMUNICATION,
        label: 'web.navigation.communication',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'privacy-policy',
        slug_cs: 'zasady-ochrany-osobnich-udaju',
        slug_old: 'privacy_policy',
        component: COMPONENTS.PRIVACYPOLICY,
        label: 'web.footer.privacy.policy',
        main: false,
        footer: true,
        new_tab: true,
      },
      {
        slug_en: 'nbcb',
        slug_cs: 'nbcb',
        component: COMPONENTS.NBCB,
        label: 'web.footer.nbcb',
        main: false,
        footer: true,
        new_tab: true,
      },
      {
        slug_en: 'terms-conditions-job',
        slug_cs: 'polityka-prywatnosci-stanowisko-prace',
        slug_old: 'terms_conditions_job',
        component: COMPONENTS.TERMSCONDITIONSJOBS,
        label: 'web.footer.terms.conditions',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: 'cookies',
        slug_cs: 'cookies',
        component: COMPONENTS.COOKIES,
        label: 'web.landing.cookie.link',
        main: false,
        footer: false,
        new_tab: true,
      },
      {
        slug_en: '404',
        slug_cs: '404',
        component: COMPONENTS['404'],
        label: 'web.404.title',
        main: false,
        footer: false,
      },
    ],
  },
];

module.exports.COUNTRY_LANGUAGE_LIST = COUNTRY_LANGUAGE_LIST;
module.exports.COMPONENTS = COMPONENTS;
module.exports.BASELINKS = BASELINKS;
